var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 18.802a2 2 0 0 0-2 2v38.396a2 2 0 0 0 2 2h56a2 2 0 0 0 2-2V20.802a2 2 0 0 0-2-2zm27.274 32.694L12 23.184v36.014h56V23.171L40.714 51.496a1 1 0 0 1-1.44 0M12.483 20.802l27.511 28.559 27.511-28.559z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;